import React from 'react';

import PageLayout from '../../components/layout/PageLayout';
import HistoryIndex from '../../components/club/HistoryIndex';

const HistoryPage = () => {
  return (
    <PageLayout>
      <HistoryIndex />
    </PageLayout>
  );
};

export default HistoryPage;
